/**
 * Mahindra University identity block — official logo + wordmark.
 * Use `elevated` on dark/colored surfaces (login); default white card for sidebar.
 */
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_uni-ticket-hub/artifacts/lp2trgac_MU_logo%204.png";

export default function MahindraLogo({
  className = "",
  compact = false,
  size,
  transparent = false,
  elevated = false,
}) {
  const resolvedSize = size ?? (compact ? "compact" : "default");

  const imageHeights = {
    compact: "h-8",
    default: "h-[72px]",
    hero: "h-24",
  };

  const elevatedPadding = {
    compact: "px-5 py-3",
    default: "px-5 py-3",
    hero: "px-8 py-5",
  };

  const surfaceClass = elevated
    ? `rounded-2xl bg-white ${elevatedPadding[resolvedSize]} shadow-[0_10px_30px_rgba(0,0,0,0.18)] ring-1 ring-white/80`
    : transparent
      ? ""
      : "bg-white rounded-xl";

  return (
    <div
      className={`flex items-center justify-center ${surfaceClass} ${className}`}
      style={elevated || transparent ? undefined : { minHeight: resolvedSize === "compact" ? 48 : 92 }}
      data-testid="mahindra-logo"
    >
      <img
        src={LOGO_URL}
        alt="Mahindra University"
        className={`${imageHeights[resolvedSize]} w-auto max-w-full object-contain`}
        draggable={false}
      />
    </div>
  );
}
